import { MESSAGES, IS_AUTHENTICATED, SET_ALICE_HISTORY, SET_BUOW_DETAILS, SET_USER_INFO } from '../constants';

const initialState = { messages: [], isAuthenticated: false, aliceHistory: [], buowDetails: [], userInfoRedux: {} };

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case MESSAGES:
      return { ...state, messages: (state.messages = action.data) };
    case IS_AUTHENTICATED:
      return { ...state, isAuthenticated: (state.isAuthenticated = action.data) };
    case SET_ALICE_HISTORY:
      return { ...state, aliceHistory: action.data };
    case SET_BUOW_DETAILS:
      return { ...state, buowDetails: action.data };
    case SET_USER_INFO:
      return { ...state, userInfoRedux: action.data };
    default:
      return state;
  }
};

export default rootReducer;
